<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col cols="12" lg="6">
        <b-form-group>
          <label for="exsborder_firm" class="form-control-label">
            {{ $t('views.userdataemployee.form.employee') }}:
          </label>
          <base-select-input
            v-model="item.employee"
            :search-callback="userDataSearchCallback"
            :query-param="'userdata'"
            :display-values="['fullName', 'firmname1']"
            :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
          ></base-select-input>
          <div
            v-if="isInvalid('firm')"
            class="invalid-feedback">{{ violations.firm }}</div>
        </b-form-group>
      </b-col>
      <b-col cols="12" lg="3">
        <div class="form-group">
          <label
                  for="userdataemployee_isContactPerson"
                  class="form-control-label">{{ $t('views.userdataemployee.form.isContactPerson') }}:</label>
          <fg-input>
            <el-select
                    id="exsbbatchnumber_invoiceType"
                    class="select-default"
                    filterable
                    v-model="item.isContactPerson">
              <el-option v-for="option in contactOptions"
                         class="select-default"
                         :value="option.value"
                         :label="option.text"
                         :key="option.value">
              </el-option>
            </el-select>
          </fg-input>
          <div
                  v-if="isInvalid('isContactPerson')"
                  class="invalid-feedback">{{ violations.isContactPerson }}</div>
        </div>
      </b-col>
      <b-col cols="12" lg="3">
        <div class="form-group">
          <label
            for="userdataemployee_vatInvoiceRecipient"
            class="form-control-label">{{ $t('views.userdataemployee.form.vatInvoiceRecipient') }}:</label>
          <fg-input>
            <el-select
              id="userdataemployee_vatInvoiceRecipient"
              class="select-default"
              filterable
              v-model="item.vatInvoiceRecipient">
              <el-option v-for="option in contactOptions"
                         class="select-default"
                         :value="option.value"
                         :label="option.text"
                         :key="option.value">
              </el-option>
            </el-select>
          </fg-input>
          <div
            v-if="isInvalid('vatInvoiceRecipient')"
            class="invalid-feedback">{{ violations.vatInvoiceRecipient }}</div>
        </div>
      </b-col>
      <b-col cols="12" v-if="caseTypes && caseTypes.length > 0">
        <div class="form-group">
          <label
            for="documenttype_caseTypesAllowedForNotification"
            class="form-control-label">{{$t('views.userdataemployee.form.caseTypesAllowedForNotification')}}:</label>
          <b-form-group>
            <b-form-checkbox-group
              v-model="item.caseTypesAllowedForNotification"
              :options="caseTypes"
              name="documenttype_caseTypesAllowedForNotification"
            ></b-form-checkbox-group>
          </b-form-group>
          <div
            v-if="isInvalid('caseTypesAllowedForNotification')"
            class="invalid-feedback">{{ violations.caseTypesAllowed }}</div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="mt-3">
        <button type="submit" class="btn btn-success">{{ $t('buttons.submit') }}</button>
        <b-btn variant="danger" @click="closeModal()">{{ $t('buttons.cancel') }}</b-btn>
      </b-col>
    </b-row>
  </form>
</template>

<script>
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput'
import ApiService from '@/utils/ApiService'
import getId from '@/utils/getIdFromLink'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    BaseSelectInput
  },
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      routeName: '',
      employeesOptions: [],
      contactOptions: [
        {
          value: 0,
          text: this.$t('buttons.no')
        },
        {
          value: 1,
          text: this.$t('buttons.yes')
        }
      ]
    }
  },

  created () {
    this.routeName = this.$route.name
    this.getCaseType()
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },
    violations () {
      return this.errors || {}
    },
    caseTypes () {
      return this.casetype.map(entry => {
        return {
          value: getId(entry['@id']),
          text: entry.title
        }
      })
    },
    ...mapGetters({
      casetype: 'excmcasetype/list/items'
    })
  },

  methods: {
    closeModal () {
      if (this.item['@id']) {
        this.$store.state.modals.userdataemployee.update.close = 1
      } else {
        this.$store.state.modals.userdataemployee.create.close = 1
      }
    },
    async userDataSearchCallback (params = {}) {
      let baseParams = { pagination: false, isCompany: 0, isContractor: 0 }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    ...mapActions({
      getCaseType: 'excmcasetype/list/default'
    })
  }
}
</script>
